import { ReactNode } from "react";
import { store } from "@src/store";
import {
  // toast
  showToast,
  removeToast,
  clearToasts,
  IToast,
  IToastOption,
  // snackbar
  showSnackbar,
  removeSnackbar,
  clearSnackbars,
  ISnackbar,
  ISnackbarOption,
} from "@src/@slice/toastSlice";

import { PartnerType } from "@src/define/partner";
import { HOSTNAME, isExternalUrl } from "@src/utils";

export type { IToast, IToastOption, ISnackbar, ISnackbarOption };

class Toast {
  // 토스트 관련
  getAllToasts() {
    const state = store.getState();
    return state.toast.toasts;
  }
  getLastToastId() {
    const state = store.getState();
    return state.toast.lastToastId;
  }
  hasToast(toastId: number | string) {
    const toasts = this.getAllToasts();
    return toasts.some((toast) => toast.id === toastId);
  }
  showToast(message: string | ReactNode, options?: IToastOption) {
    const toastId = options?.customToastId ?? this.getLastToastId() + 1;
    if (this.hasToast(toastId) === true) {
      console.error("toast id is duplicated");
      return;
    }
    store.dispatch(showToast({ id: toastId, message, ...options }));
  }
  removeToast(toastId: number | string) {
    store.dispatch(removeToast(toastId));
  }
  clearToasts() {
    store.dispatch(clearToasts());
  }
  // 스낵바 관련
  getAllSnackbars() {
    const state = store.getState();
    return state.toast.snackbars;
  }
  getLastSnackbarId() {
    const state = store.getState();
    return state.toast.lastSnackbarId;
  }
  hasSnackbar(snackbarId: number | string) {
    const snackbars = this.getAllSnackbars();
    return snackbars.some((snackbar) => snackbar.id === snackbarId);
  }
  showSnackbar(message: string | ReactNode, options?: ISnackbarOption) {
    const snackbarId = options?.customToastId ?? this.getLastSnackbarId() + 1;
    if (this.hasSnackbar(snackbarId) === true) {
      console.error("snackbar id is duplicated");
      return;
    }
    store.dispatch(showSnackbar({ id: snackbarId, message, ...options }));
  }
  showErrorSnackbar(message: string | ReactNode, options?: ISnackbarOption) {
    const snackbarId = options?.customToastId ?? this.getLastSnackbarId() + 1;
    if (this.hasSnackbar(snackbarId) === true) {
      console.error("snackbar id is duplicated");
      return;
    }
    store.dispatch(showSnackbar({ id: snackbarId, message, type: "error", ...options }));
  }
  removeSnackbar(snackbarId: number | string) {
    store.dispatch(removeSnackbar(snackbarId));
  }
  clearSnackbars() {
    store.dispatch(clearSnackbars());
  }
  // --------------------- special action
  // 업체 위시리스트 스낵바
  showLikeSnackbar(currentIsLike: boolean, partnerType?: number) {
    let likePageUrl = "";
    if (partnerType === PartnerType.Planner) {
      likePageUrl = `${HOSTNAME}/my-interest/like/planner?tab=planner`;
    } else {
      likePageUrl = `${HOSTNAME}/my-interest/like/partner?tab=${partnerType || 0}`;
    }

    let message = "";
    let snackbarOptions: ISnackbarOption = {};

    if (currentIsLike === false) {
      message = "위시리스트에 추가했습니다.";
      snackbarOptions = {
        buttonText: "위시리스트 가기",
        onClick: () => {
          window.location.href = isExternalUrl(likePageUrl);
        },
      };
    } else {
      message = "위시리스트에서 삭제했습니다.";
      snackbarOptions = {
        isShowClose: true,
      };
    }

    store.dispatch(showSnackbar({ message, ...snackbarOptions }));
  }
  // 포트폴리오 위시리스트 스낵바
  showPortfolioLikeSnackbar(currentIsLike: boolean) {
    let message = "";
    let snackbarOptions: ISnackbarOption = {};

    if (currentIsLike === false) {
      message = "위시리스트에 추가했습니다.";
      snackbarOptions = {
        buttonText: "위시리스트 가기",
        onClick: () => {
          window.location.href = isExternalUrl(
            `${HOSTNAME}/my-interest/like/planner?tab=portfolio`,
          );
        },
      };
    } else {
      message = "위시리스트에서 삭제했습니다.";
      snackbarOptions = {
        isShowClose: true,
      };
    }

    store.dispatch(showSnackbar({ message, ...snackbarOptions }));
  }
}

const _instance = new Toast();
export default _instance;
